const RiskProfitTable = require('./RiskProfitTable');

module.exports = RiskProfitTable;
